import { FUNDRAISER_TABS } from '../constants';

export function validateFundraiserForm(values) {
	const { CHOOSE_YOUR_CAUSE, BASIC_INFO, TELL_A_STORY } = FUNDRAISER_TABS;

	let errors = {};
	switch (values.tab) {
		case CHOOSE_YOUR_CAUSE: {
			const goal = parseInt(values.goal, 10);
			if (!values.goal || !(goal > 0)) {
				errors.goal = 'Goal amount is required';
			} else if (goal > 10000000000) {
				errors.goal = 'Goal amount cannot exceed 10 billion';
			}
			break;
		}

		case BASIC_INFO: {
			const name = values.name ? values.name.trim() : '';
			if (!name) {
				errors.name = 'Page name is required';
			} else if (name.length > 70) {
				errors.name = 'Page name cannot exceed 70 characters';
			} else if (!/^[a-zA-Z0-9\s!,&'".\-()#@]+$/.test(name)) {
				errors.name = 'Page name cannot contain special characters';
			} else if (!/[a-zA-Z]/.test(name)) {
				errors.name = 'Page name cannot contain only special characters';
			}
			break;
		}

		case TELL_A_STORY: {
			if (!values.missionStatement) {
				errors.missionStatement = 'Mission statement is required';
			}
			break;
		}

		default:
			break;
	}

	return errors;
}
